<template>
    <el-date-picker :value="dateValue" v-bind="$attrs" @input="input($event)" :type="type">
    </el-date-picker>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "DatePicker",
        props: {
            value: [String, Array],
            type: {
                type: String,
                default: 'date',
                validator: function (value) {
                    return ['date', 'datetime'].indexOf(value) !== -1
                }
            }
        },
        inheritAttrs: false,
        computed: {
            dateValue() {
                if (Array.isArray(this.value)) {
                    return this.value.map(item => item ? new Date(moment(item, this.valueFormat).valueOf()) : null)
                } else if (this.value) {
                    return new Date(moment(this.value, this.valueFormat).valueOf())
                } else {
                    return null
                }
            },
            valueFormat(){
                if(this.type === 'date'){
                    return 'YYYY-MM-DD'
                }else{
                    return 'YYYY-MM-DD[T]HH:mm:ss.SSSZZ'
                }
            }
        },
        methods: {
            input(newValue) {
                if (Array.isArray(newValue)) {
                    this.$emit('input', newValue.map(item => item ? moment(item).format(this.valueFormat) : null))
                } else if (newValue) {
                    this.$emit('input', moment(newValue).format(this.valueFormat))
                } else {
                    this.$emit('input', null)
                }
            }
        }
    }
</script>
